import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'

import VuejsDialog from 'vuejs-dialog'
import VueClipboard from 'vue-clipboard2'

import App from './App'
import router from './router'
import store from './store'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAt,
  faLock,
  faCheckDouble,
  faTrash,
  faPlus,
  faNetworkWired,
  faShoppingCart,
  faCreditCard,
  faUser,
  faPaste,
  faToggleOff,
  faToggleOn,
  faHome,
  faSignOutAlt,
  faCircle,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './assets/style.css'

library.add(
  faAt,
  faLock,
  faCheckDouble,
  faTrash,
  faTimes,
  faPlus,
  faCreditCard,
  faPaste,
  faToggleOff,
  faToggleOn,
  faShoppingCart,
  faHome,
  faUser,
  faNetworkWired,
  faSignOutAlt,
  faCircle
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
  fieldsBagName: 'fieldBag',
  events: 'input|change|blur'
})
Vue.use(VuejsDialog)
Vue.use(VueClipboard)

Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})

/* eslint-disable no-new,no-console */
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// ga('set', 'page', router.currentRoute.path)
// ga('send', 'pageview')

// router.afterEach((to, from) => {
//   ga('set', 'page', to.path)
//   ga('send', 'pageview')
// })
